<template>
  <b-card>
    <FormBuilder
      label="Administrator"
      update
      :data="$store.getters['administratorV2/detailData']"
      :fields="fields"
      :loading-detail="$store.state.administratorV2.loadingDetail"
      :loading-submit="$store.state.administratorV2.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import { BCard } from 'bootstrap-vue'
import fields from '@/field/form/administrator'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return { fields }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('administratorV2/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('administratorV2/update', { id, data })
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
    resetData() {
      this.$store.commit('administratorV2/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>
